<template>
  <div>
    <draggable v-model="fileList" style="display: inline-block" :disabled="disabled">
      <!-- 遍历图片列表 -->
      <div class="uploadImgList-single" v-for="img in fileList" :key="img.resourceId" @click="handlePreview(img)">
          <div class="img-cover" :style="{backgroundImage:'url(' + img.url + ')'}"></div>
        <!-- </a> -->
        <!-- 删除图标 - 只在非禁用状态下显示 -->
        <i
          v-if="!disabled"
          class="el-icon-delete"
          @click.stop="handleRemove(img)"
          style="position: absolute; top: 5px; right: 5px; font-size: 18px; cursor: pointer; color: #f56c6c;"
        >
        </i>
      </div>
    </draggable>
    <!-- 上传按钮 - 只在非禁用状态下显示 -->
    <el-upload
      v-if="!disabled"
      class="upload-button"
      :action="uploadUrl"
      list-type="picture-card"
      :show-file-list="false"
      :on-preview="handlePictureCardPreview"
      :on-success="handleSuccess"
      :data="paramsObj"
      accept="image/*"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
        <!-- 图片预览弹窗 -->
        <el-dialog  :visible.sync="viewImgDialogVisible" custom-class="my-image-dialog"  append-to-body width="40%"  top="5vh" @close="handleClose">
          <!-- 新增：外层容器，控制整体布局 -->
          <div class="preview-content-wrapper">
            <!-- 1. 旋转和缩放控制栏 (独立于图片层) -->
            <div class="rotate-toolbar">
              <el-button type="primary" icon="el-icon-refresh-left" circle @click="rotate(-90)" title="向左旋转" :disabled="false"></el-button>
              <el-button type="primary" icon="el-icon-refresh-right" circle @click="rotate(90)" title="向右旋转" :disabled="false"></el-button>
              <span class="toolbar-divider"></span>
              <el-button type="primary" icon="el-icon-zoom-in" circle @click="zoomIn" title="放大" :disabled="false"></el-button>
              <el-button type="primary" icon="el-icon-zoom-out" circle @click="zoomOut" title="缩小" :disabled="false"></el-button>
              <el-button type="primary" icon="el-icon-refresh" circle @click="resetZoom" title="重置" :disabled="false"></el-button>
            </div>

            <!-- 2. 图片显示区域 (固定尺寸，防止溢出) -->
            <div class="image-viewer">
              <img :src="dialogImageUrl"  class="rotatable-image"  :style="imageStyle" />
            </div>
          </div>
        </el-dialog>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { getToken } from '@/utils/auth';

export default {
  name: "index",
  props: ['fileList', 'businessType', 'disabled','targetId'], // 添加 disabled prop
  data() {
    return {
      dialogImageUrl: '',  // 预览图片的 URL
      viewImgDialogVisible: false,  // 是否显示预览弹窗
      rotateDegree: 0,
      scale: 1, // 图片缩放比例
      uploadUrl: process.env.FILE_URL + "/fileWeb/uploadResource",  // 上传接口 URL
      paramsObj: { accessToken: getToken() },  // 上传时的额外参数
    };
  },
  watch: {
    // 监听 fileList 变化，更新上传参数并重新加载资源列表
    fileList(list) {
      this.$emit('confirm', list);
    },
  },
  created() {
    // 初始化时设置上传所需的 accessToken
    this.paramsObj['accessToken'] = getToken();
    this.paramsObj['businessType'] = this.businessType;
    this.paramsObj['targetId'] = this.targetId;
  },
  computed: {
      //预览图片旋转、放大缩小样式
      imageStyle() {
          return {
            transform: `rotate(${this.rotateDegree}deg) scale(${this.scale})`,
            transition: 'transform 0.3s ease',
            'transform-origin': 'center center'
          };
        }
  },
  components: {
    draggable
  },
  methods: {
      //预览功能
      handlePreview(img) {
        if (!img || !img.url) return;
        this.dialogImageUrl = img.url;
        this.viewImgDialogVisible = true;
      },
      handleClose() {
        this.rotateDegree = 0;
        this.scale = 1; // 重置缩放比例
      },
      // 新增：旋转方法
      rotate(deg) {
        this.rotateDegree += deg;
      },
      // 新增：缩放方法
      zoomIn() {
        if (this.scale < 3) { // 限制最大缩放比例为3倍
          this.scale += 0.1;
        }
      },
      zoomOut() {
        if (this.scale > 0.5) { // 限制最小缩放比例为0.5倍
          this.scale -= 0.1;
        }
      },
      resetZoom() {
        this.scale = 1; // 重置缩放比例
      },
    // 删除文件时的回调
    handleRemove(file) {
      if (this.disabled) {
        return; // 禁用状态下不执行删除操作
      }

      this.$confirm(`确定要删除这个图片吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const index = this.fileList.findIndex(f => f.resourceId === file.resourceId);
        if (index > -1) {
          this.fileList.splice(index, 1); // 从 fileList 中移除该文件
        }
        return this.request({
          method:'post',
          url:'/web/service?method=tCoreResource_delete&businessType='+this.businessType,
          params: {'id': file.resourceId}
        }).then((response) => {
          if(response.code != '0'){
            this.$message.error(response.msg);
            return false;
          }
          this.$emit('confirm', this.fileList);
        })
      }).catch(() => {})
    },

    // 预览图片的回调
    handlePictureCardPreview(file) {
      this.dialogVisible = true;  // 显示弹窗
      this.dialogImageUrl = file.url;
    },

    // 上传成功时的回调
    handleSuccess(response) {
      if (this.disabled) {
        return; // 禁用状态下不执行上传操作
      }
      // 如果返回的编码不为 '0'，表示上传失败，提示错误
      if (response.code != '0') {
        this.$message.error(response.msg);
        return false;
      }

      // 手动将上传成功的文件添加到 fileList
      let uploadedFile = {
        resourceId: response.resourceId,
        url: process.env.FILE_URL + "/web/getResource/" + response.resourceId,
        fileName: response.fileName
      };

      this.fileList.push(uploadedFile);
    },
  }
};
</script>

<style scoped>
.uploadImgList-single {
  cursor: pointer;
  position: relative;
  display: inline-block;
  height: 120px;
  width: 120px;
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 6px;
  border: 1px solid #ddd;
  background: #fff;
}

.uploadImgList-single .img-cover {
  display: block;
  width: 100%;
  height: 100%;
  background: no-repeat 50%/100%;
}

.uploadImgList-single .el-icon-delete {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 18px;
  cursor: pointer;
  color: #f56c6c;
}

.upload-button {
  display: inline;
}

/deep/.upload-button .el-upload--picture-card {
  height: 120px;
  width: 120px;
  line-height: 120px;
}

/* 禁用状态下的样式 */
.disabled .uploadImgList-single {
  cursor: not-allowed;
  opacity: 0.6;
}

.disabled .uploadImgList-single .el-icon-delete {
  display: none;
}

.disabled .upload-button {
  display: none;
}
.my-image-preview-dialog {
  z-index: 6666 !important;
}
.image-preview-container {
  text-align: center;
  position: relative;
  max-height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
}
.preview-content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}

.rotate-toolbar {
  margin-bottom: 20px;
  padding: 10px 20px;
  background: #f5f7fa;
  border-radius: 8px;
  border: 1px solid #e4e7ed;
  display: flex;
  align-items: center;
  gap: 10px; /* 按钮间距 */
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05);
  z-index: 10;
}

.rotate-tip {
  font-size: 14px;
  color: #b3b9c1;
  margin: 0 5px;
}

.rotate-toolbar .el-button--circle {
  padding: 8px;
}

.toolbar-divider {
  width: 1px;
  height: 24px;
  background-color: #e4e7ed;
  margin: 0 10px;
}

.image-viewer {
  width: 100%;
  height: 60vh;
  background-color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 4px;
}

.rotatable-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/XrUploadImg/index.vue